<script setup lang="ts">
export interface IconCreditCardTypeProps {
  type?: TCreditCard;
}
const props = defineProps<IconCreditCardTypeProps>();
</script>

<template>
  <IconCreditCardVisa v-if="props.type === 'visa'" />
  <IconCreditCardMasterCard v-else-if="props.type === 'mastercard'" />
  <IconCreditCardAxp v-else-if="props.type === 'amex'" />
  <IconCreditCardDiscover v-else-if="props.type === 'discover'" />
</template>
